import EnumCombo, { EnumComboProps } from "../../components/form/EnumCombo";
import { LocationType, locationTypes } from "../../models/Enums";

export default function LocationTypeCombo(props: EnumComboProps<LocationType>) {
    return <EnumCombo<LocationType> {...props} enumNames={locationTypes} />
}